 
import { FaceFrownIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
 
export default function NotFound() {
  return (
    <main className="flex h-full flex-col items-center justify-center gap-2">
      <FaceFrownIcon className="w-10 text-gray-400" />
      <h2 className="text-xl font-semibold">404 Not Found</h2>
      <p>Could not find the requested users.</p>
      <Link
        to="/admin/users"
        className="mt-4 rounded-md bg-purple-500 px-4 py-2 text-sm text-white transition-colors hover:bg-purple-400"
      >
        Go Back
      </Link>
    </main>
  );
}